/* Native product and cart forms remain usable without this enhancement. */
(() => {
  'use strict';
  const $ = (s, root=document) => root.querySelector(s);
  const $$ = (s, root=document) => Array.from(root.querySelectorAll(s));
  const root = document.body.dataset.root || '/';
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  let currency = document.body.dataset.currency || 'MXN';
  const formats = new Map();
  function money(cents, compact=false) {
    const key=currency+compact;
    if(!formats.has(key)) formats.set(key,new Intl.NumberFormat('es-MX',{style:'currency',currency,minimumFractionDigits:compact?0:2,maximumFractionDigits:2}));
    return formats.get(key).format(cents/100)+(compact?'':' '+currency);
  }
  const purchaseMoney = cents => money(cents,true);
  const announce = text => {const region=$('#cart-announcement');if(region)region.textContent=text;};
  const el = (tag, className, text) => {const node=document.createElement(tag);if(className)node.className=className;if(text!==undefined)node.textContent=text;return node;};
  const drawer = $('#cart-drawer');
  const supportsDialog = !!(drawer && typeof drawer.showModal==='function');
  const dialogs = new Map();
  const openers = new WeakMap(), silentClose = new WeakSet();
  let historyMoving=false, memoryOverlay=null, nextOverlay, currentVariant, syncPlayback=()=>{};

  // Each sheet/step is a same-page history entry. Back never resubmits a cart write.
  $$('dialog').forEach((dialog,index)=>{
    const kind=dialog.dataset.dialogKind || (dialog.hasAttribute('data-shade-dialog')?'shade':dialog.hasAttribute('data-mini-dialog')?'video':'dialog-'+index);
    dialog.dataset.dialogKind=kind;dialogs.set(kind,dialog);
    dialog.addEventListener('cancel',event=>{event.preventDefault();closeDialog(dialog);});
    dialog.addEventListener('close',()=>{
      if(silentClose.has(dialog)){silentClose.delete(dialog);return;}
      closeDialog(dialog);
    });
    dialog.addEventListener('click',event=>{
      if(event.target!==dialog)return;
      const r=dialog.getBoundingClientRect();
      if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)closeDialog(dialog);
    });
  });
  function overlayState(){return memoryOverlay||(history.state?.boldUI?.path===location.pathname?history.state.boldUI:{path:location.pathname,depth:0,stack:[]});}
  function syncDialogs(state) {
    for(const [kind,dialog] of dialogs){
      const entry=state.stack.find(s=>s.kind===kind);
      if(!entry&&dialog.open){silentClose.add(dialog);dialog.close();}
      if(entry){if(!dialog.open&&typeof dialog.showModal==='function')dialog.showModal();dialog.dispatchEvent(new CustomEvent('bold:step',{detail:entry.step||1}));}
    }
    document.documentElement.classList.toggle('dialog-open',!!$('dialog[open]'));
    document.body.classList.toggle('dialog-open',!!$('dialog[open]'));
    syncPlayback();
  }
  function pushOverlay(stack) {
    const state={path:location.pathname,depth:overlayState().depth+1,stack};
    if(memoryOverlay)memoryOverlay=state;
    else try{history.pushState({...history.state,boldUI:state},'',location.href);}catch{memoryOverlay=state;}
    syncDialogs(state);
  }
  function openDialog(dialog,opener) {
    if(!dialog||dialog.open||historyMoving)return;
    openers.set(dialog,opener);
    const state=overlayState();
    pushOverlay([...state.stack,{kind:dialog.dataset.dialogKind,step:1,depth:state.depth+1}]);
  }
  function closeDialog(dialog) {
    if(historyMoving)return;
    const state=overlayState(),index=state.stack.findIndex(s=>s.kind===dialog.dataset.dialogKind);
    const remaining=index>=0?state.stack.slice(0,index):[];
    syncDialogs({...state,stack:remaining});
    openers.get(dialog)?.focus({preventScroll:true});
    if(memoryOverlay){memoryOverlay={...state,depth:remaining.length,stack:remaining};const next=nextOverlay;nextOverlay=null;if(next)next();return;}
    if(index>=0){historyMoving=true;history.go(-(state.depth-state.stack[index].depth+1));}
  }
  function replaceWithCart(opener) {
    const state=overlayState();
    if(memoryOverlay){memoryOverlay={path:location.pathname,depth:0,stack:[]};syncDialogs(memoryOverlay);openCart(opener);return;}
    if(state.depth&&state.stack.length){
      nextOverlay=()=>openCart(opener);historyMoving=true;syncDialogs({...state,stack:[]});history.go(-state.depth);
    }else openCart(opener);
  }
  window.addEventListener('popstate',()=>{
    historyMoving=false;memoryOverlay=null;
    if(currentVariant&&location.pathname.startsWith(root+'products/')){
      const url=new URL(location.href);url.searchParams.set('variant',currentVariant);try{history.replaceState(history.state,'',url);}catch{/* Selection still works when URL writes are restricted. */}
    }
    const closing=$$('dialog[open]').filter(dialog=>!overlayState().stack.some(s=>s.kind===dialog.dataset.dialogKind));
    syncDialogs(overlayState());
    // Android may restore this history entry after pageshow has already run.
    if(drawer?.open)loadCart();
    if(closing.length)openers.get(closing[0])?.focus({preventScroll:true});
    const next=nextOverlay;nextOverlay=null;if(next)next();
  });
  document.addEventListener('click',event=>{
    const close=event.target.closest('[data-close-dialog]');if(close)closeDialog(close.closest('dialog'));
    const guarantee=event.target.closest('[data-guarantee-open]');if(guarantee)openDialog($('[data-guarantee-dialog]'),guarantee);
    const search=event.target.closest('[data-search-open]'),searchDialog=$('#header-search');
    if(search&&typeof searchDialog?.showModal==='function'&&!event.metaKey&&!event.ctrlKey&&!event.shiftKey&&!event.altKey){
      event.preventDefault();openDialog(searchDialog,search);$('input[type="search"]',searchDialog).focus({preventScroll:true});
    }
  });

  async function request(path,options={}) {
    const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),20000);
    try{
      const response=await fetch(root+path,{credentials:'same-origin',...options,signal:controller.signal,headers:{Accept:'application/json',...options.headers}});
      let data;try{data=await response.json();}catch{throw new Error('No pudimos leer la respuesta. Revisa tu carrito antes de intentarlo de nuevo.');}
      if(!response.ok)throw new Error(typeof data.description==='string'?data.description:'No pudimos actualizar tu carrito. Inténtalo de nuevo.');
      return data;
    }catch(error){
      if(error.name==='AbortError'||error instanceof TypeError)throw new Error('La conexión está tardando. Revisa tu carrito antes de volver a agregar el producto.');
      throw error;
    }finally{clearTimeout(timer);}
  }
  const post = (path,data) => request(path,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(data)});
  const gifts=window.BoldCartGifts;
  const visibleCartItems=cart=>gifts?gifts.visibleItems(cart):cart.items;
  const visibleCartCount=cart=>visibleCartItems(cart).reduce((sum,item)=>sum+item.quantity,0);
  const syncGiftCart=cart=>{
    if(!gifts)throw new Error('No pudimos cargar tus regalos. Actualiza la página antes de continuar al pago.');
    return gifts.sync(cart,request,post);
  };
  const products=new Map();
  let cartBusy=false, cartUncertain=false, latestCart, checkoutSubmitted=false, checkoutOpening=false, checkoutTimer;
  function lockCart(busy) {
    cartBusy=busy;
    if(drawer){
      drawer.setAttribute('aria-busy',String(busy));
      $$('[data-change-key],[data-quantity-key],[data-cart-tone]',drawer).forEach(control=>{control.disabled=busy;});
      $('[data-checkout]',drawer).disabled=busy||checkoutOpening||cartUncertain||!latestCart?.item_count;
    }
    document.dispatchEvent(new Event('bold:cart-busy'));
  }
  function showCartError(message){const box=$('[data-cart-error]');if(box){box.textContent=message;box.hidden=!message;}}
  function openCart(opener){
    if(!supportsDialog){location.assign(root+'cart');return;}
    // A second tap on Add can land on the new drawer's checkout at the same position.
    checkoutOpening=true;clearTimeout(checkoutTimer);lockCart(cartBusy);openDialog(drawer,opener);
    checkoutTimer=setTimeout(()=>{checkoutOpening=false;lockCart(cartBusy);},450);
  }
  async function productFor(item) {
    const handle=item.handle||item.url?.split('/products/')[1]?.split('?')[0];
    if(!handle)return null;
    if(!products.has(handle))products.set(handle,request('products/'+encodeURIComponent(handle)+'.js').catch(()=>{products.delete(handle);return null;}));
    return products.get(handle);
  }
  async function addToneSelect(item,holder) {
    if(item.selling_plan_allocation||Object.keys(item.properties||{}).length)return;
    const product=await productFor(item);
    if(!holder.isConnected||!product)return;
    const option=product.options?.[0],name=typeof option==='string'?option:option?.name;
    if(!/^(tono|color|colour)$/i.test(name||''))return;
    const variant=product.variants.find(v=>String(v.id)===String(item.variant_id||item.id));
    if(!variant)return;
    const select=el('select','cart-tone');select.dataset.cartTone=item.key;
    select.setAttribute('aria-label','Tono de '+item.product_title+', '+variant.options.slice(1).join(' / '));
    for(const v of product.variants.filter(v=>v.options.slice(1).every((o,i)=>o===variant.options[i+1]))){
      const option=el('option','',v.options[0]+(!v.available?' · Agotado':''));option.value=String(v.id);option.selected=v.id===variant.id;option.disabled=!v.available;select.append(option);
    }
    select.disabled=cartBusy;holder.replaceChildren(select);
  }
  async function updateCartSavings(cart,lines) {
    const details=await Promise.all(lines.map(({item})=>productFor(item)));
    if(latestCart!==cart)return;
    let originalTotal=0,comparisonSavings=0;
    lines.forEach(({item,previous},index)=>{
      const original=Number(item.original_line_price??((item.original_price??item.price)*item.quantity))||0;
      const variant=details[index]?.variants.find(v=>String(v.id)===String(item.variant_id||item.id));
      const comparison=Math.max(original,(Number(variant?.compare_at_price)||0)*item.quantity);
      originalTotal+=original;comparisonSavings+=comparison-original;
      previous.hidden=comparison<=item.final_line_price;
      previous.textContent=money(comparison);
    });
    // Compare-at markdowns and applied cart discounts are separate savings.
    const applied=Math.max(0,Number(cart.total_discount??(originalTotal-cart.total_price))||0);
    const savings=comparisonSavings+applied;
    $('[data-cart-discounts]').textContent=(savings?'−':'')+money(savings);
  }
  function renderCart(cart) {
    latestCart=cart;currency=cart.currency||currency;cartUncertain=false;
    const visibleItems=visibleCartItems(cart),count=visibleCartCount(cart);
    $$('[data-cart-count]').forEach(node=>{node.textContent=node.classList.contains('cart-count')&&count>99?'99+':count;node.hidden=count===0;});
    $$('.header-actions [data-cart-open]').forEach(node=>node.setAttribute('aria-label','Abrir carrito, '+count+(count===1?' artículo':' artículos')));
    $('[data-cart-discounts]').textContent='…';
    $('[data-checkout-total]').textContent=money(cart.total_price);
    $('[data-cart-reservation]').hidden=!count;
    $('[data-cart-shipping]').hidden=!count;
    $('[data-cart-footer]').hidden=!count;
    const list=$('[data-cart-items]'),lines=[];list.replaceChildren();
    if(!visibleItems.length){
      const empty=el('div','cart-empty');empty.append(el('p','','Tu carrito está vacío.'));
      const keep=el('button','button','Seguir comprando');keep.type='button';keep.dataset.closeDialog='';empty.append(keep);list.append(empty);
    }
    for(const item of visibleItems){
      const row=el('article','drawer-item'),info=el('div','drawer-item-info'),top=el('div','drawer-item-top');
      const packCount=parseInt(item.variant_title?.split(' / ').pop(),10);
      const packImage=item.handle==='bold-density'?drawer.dataset['densityPack'+packCount]:null;
      const imageSource=packImage||item.image;
      if(imageSource){const image=el('img');image.src=imageSource;image.alt=item.product_title+(packImage?' — '+item.variant_title.split(' / ').pop():'');image.width=80;image.height=90;image.loading='lazy';row.append(image);}else row.append(el('div'));
      const link=el('a');link.href=item.url;link.append(el('h3','',item.product_title));
      const prices=el('div','cart-line-prices');prices.append(el('strong','',money(item.final_line_price)));
      const previous=el('s');previous.hidden=true;prices.append(previous);lines.push({item,previous});
      top.append(link,prices);info.append(top);
      info.append(el('p','cart-stock','Últimas unidades disponibles'));
      if(item.variant_title&&item.variant_title!=='Default Title')info.append(el('p','cart-pack',(t=>({'1 bote':'Compra 1','2 botes':'Compra 1 + 1 GRATIS','3 botes + 1 gratis':'Compra 2 + 2 GRATIS'}[t]||t))(item.variant_title.split(' / ').slice(1).join(' / '))));
      const tone=el('div','cart-tone-wrap',item.variant_title?.split(' / ')[0]||'');info.append(tone);addToneSelect(item,tone);
      for(const discount of item.line_level_discount_allocations||[])info.append(el('p','cart-discount',discount.discount_application.title+' −'+money(discount.amount)));
      const controls=el('div','drawer-item-controls'),quantity=el('div','quantity-control');
      for(const delta of [-1,1]){
        const button=el('button','',delta===-1?'−':'+');button.type='button';button.setAttribute('aria-label',(delta===-1?'Reducir':'Aumentar')+' cantidad de '+item.product_title);button.dataset.changeKey=item.key;button.dataset.quantity=String(item.quantity+delta);quantity.append(button);
        if(delta===-1){const input=el('input');input.type='number';input.min='1';input.step='1';input.inputMode='numeric';input.value=String(item.quantity);input.dataset.quantityKey=item.key;input.setAttribute('aria-label','Cantidad de '+item.product_title);quantity.append(input);}
      }
      const remove=el('button','remove-item','Eliminar');remove.type='button';remove.dataset.changeKey=item.key;remove.dataset.quantity='0';remove.setAttribute('aria-label','Eliminar '+item.product_title+' '+item.variant_title);
      controls.append(quantity,remove);info.append(controls);row.append(info);
      if(item.handle==='bold-density'){
        const template=$('[data-cart-gifts="'+packCount+'"]',drawer);
        if(template){const gifts=template.content.cloneNode(true),bottle=$('[data-gift-bottle-label]',gifts);if(bottle&&item.quantity>1)bottle.textContent=(item.quantity*(/3 botes/.test(item.variant_title||'')?2:1))+' botes de regalo';row.append(gifts);}
      }
      list.append(row);
    }
    updateCartSavings(cart,lines);lockCart(cartBusy);
  }
  async function refreshCart(){const cart=await syncGiftCart(await request('cart.js',{cache:'no-store'}));renderCart(cart);return cart;}
  async function loadCart() {
    if(cartBusy)return;
    lockCart(true);showCartError('');
    try{await refreshCart();}catch(error){cartUncertain=true;showCartError(error.message);}finally{lockCart(false);}
  }
  async function mutateCart(path,data,focusKey,focusLabel) {
    if(cartBusy)return;
    lockCart(true);showCartError('');
    try{
      const cart=await syncGiftCart(await post(path,data));renderCart(cart);announce('Carrito actualizado. '+visibleCartCount(cart)+' artículos.');
      const next=$$('[data-change-key],[data-quantity-key],[data-cart-tone]',drawer).find(b=>(b.dataset.changeKey||b.dataset.quantityKey||b.dataset.cartTone)===focusKey&&b.getAttribute('aria-label')===focusLabel);
      lockCart(false);(next||$('[data-close-dialog]',drawer)).focus({preventScroll:true});
    }catch(error){
      // A timeout may follow a successful write. Read the cart; never retry the write.
      try{await refreshCart();}catch{cartUncertain=true;}
      showCartError(error.message);
    }finally{lockCart(false);}
  }
  document.addEventListener('click',event=>{
    const opener=event.target.closest('[data-cart-open]');
    if(opener&&supportsDialog){event.preventDefault();openCart(opener);loadCart();return;}
    const change=event.target.closest('[data-change-key]');
    if(change)mutateCart('cart/change.js',{id:change.dataset.changeKey,quantity:Number(change.dataset.quantity)},change.dataset.changeKey,change.getAttribute('aria-label'));
  });
  drawer?.addEventListener('change',event=>{
    const control=event.target,key=control.dataset.quantityKey||control.dataset.cartTone;
    if(!key||cartBusy)return;
    const item=latestCart?.items.find(i=>i.key===key);if(!item)return;
    if(control.hasAttribute('data-quantity-key')){
      const quantity=Number(control.value);
      if(!Number.isInteger(quantity)||quantity<1){control.value=String(item.quantity);return;}
      if(quantity!==item.quantity)mutateCart('cart/change.js',{id:key,quantity},key,control.getAttribute('aria-label'));
    }else{
      const id=Number(control.value);if(id===item.id)return;
      const target=latestCart.items.find(i=>i.id===id&&!i.selling_plan_allocation&&!Object.keys(i.properties||{}).length);
      mutateCart('cart/update.js',{updates:{[key]:0,[target?.key||id]:item.quantity+(target?.quantity||0)}},target?.key||'',control.getAttribute('aria-label'));
    }
  });
  let checkoutResubmitting=false;
  document.addEventListener('submit',async event=>{
    if(event.submitter?.name!=='checkout')return;
    if(checkoutResubmitting)return;
    event.preventDefault();
    if(cartBusy||checkoutOpening||checkoutSubmitted)return;
    const form=event.target,submitter=event.submitter;
    checkoutSubmitted=true;submitter.setAttribute('aria-busy','true');lockCart(true);showCartError('');
    try{
      const quantities=$$('[data-cart-line-key]',form);
      if(quantities.length){
        const updates={};
        for(const input of quantities){const quantity=Number(input.value);if(!Number.isInteger(quantity)||quantity<0)throw new Error('Revisa las cantidades de tu carrito.');updates[input.dataset.cartLineKey]=quantity;}
        await post('cart/update.js',{updates});
      }
      const cart=await refreshCart();
      if(!visibleCartCount(cart))throw new Error('Elige tu paquete antes de continuar al pago.');
      lockCart(false);submitter.disabled=false;
      checkoutResubmitting=true;
      try{form.requestSubmit(submitter);}finally{checkoutResubmitting=false;}
    }catch(error){
      checkoutSubmitted=false;lockCart(false);submitter.removeAttribute('aria-busy');showCartError(error.message);
      const pageError=$('[data-cart-page-error]');if(pageError){pageError.textContent=error.message;pageError.hidden=false;pageError.scrollIntoView({block:'nearest'});}
    }
  });

  function setupProduct(section) {
    if(section.dataset.ready)return;section.dataset.ready='true';
    const slides=$$('[data-gallery-slide]',section),thumbs=$$('[data-gallery-index]',section);let active=0,galleryInitialized=false;
    const showSlide=index=>{
      if(!slides.length)return;active=(index+slides.length)%slides.length;
      slides.forEach((slide,i)=>{slide.hidden=i!==active;if(i!==active)$$('video',slide).forEach(v=>v.pause());});
      thumbs.forEach((thumb,i)=>thumb.setAttribute('aria-pressed',String(i===active)));
      if(galleryInitialized&&thumbs[active]){const strip=thumbs[active].parentElement;strip.scrollTo({left:thumbs[active].offsetLeft-strip.offsetLeft-strip.clientWidth/2+thumbs[active].offsetWidth/2,behavior:motion.matches?'instant':'smooth'});}
      galleryInitialized=true;
    };
    thumbs.forEach(button=>button.addEventListener('click',()=>showSlide(Number(button.dataset.galleryIndex))));
    $$('[data-gallery-step]',section).forEach(button=>button.addEventListener('click',()=>showSlide(active+Number(button.dataset.galleryStep))));
    const stage=$('[data-gallery-stage]',section);let touch;
    if(stage){
      stage.addEventListener('pointerdown',event=>{if(event.pointerType==='touch')touch={x:event.clientX,y:event.clientY};},{passive:true});
      stage.addEventListener('pointerup',event=>{if(!touch)return;const x=event.clientX-touch.x,y=event.clientY-touch.y;if(Math.abs(x)>45&&Math.abs(x)>Math.abs(y)*1.5)showSlide(active+(x<0?1:-1));touch=null;},{passive:true});
      stage.addEventListener('pointercancel',()=>{touch=null;},{passive:true});
    }
    showSlide(0);
    let product;try{product=JSON.parse($('[data-product-json]',section).textContent);}catch{return;}
    products.set(product.handle,Promise.resolve(product));
    const form=$('.product-form',section),select=$('[data-variant-select]',section),submit=$('[data-add-to-cart]',section),label=$('[data-add-label]',section),errorBox=$('[data-product-error]',section);
    if(!form||!select||!product.variants?.length)return;
    const groups=$$('[data-option-index]',form),purchase=$('[data-purchase-dialog]',section),stickyAdd=$('[data-sticky-add]',section);
    let selected,adding=false,purchaseStep=1;
    const values=()=>groups.map(group=>$('input:checked',group)?.value);
    function updatePurchase() {
      if(!purchase)return;
      const next=$('[data-purchase-next]',purchase),choices=values();
      purchase.dataset.step=String(purchaseStep);
      $$('[data-purchase-pane]',purchase).forEach(pane=>{pane.hidden=Number(pane.dataset.purchasePane)!==purchaseStep;});
      $('[data-purchase-progress]',purchase).textContent='PASO '+purchaseStep+' DE 2';
      $('[data-purchase-title]',purchase).textContent=purchaseStep===1?'Elige tu tono':'Elige tu paquete';
      $('.purchase-head [data-purchase-back]',purchase).hidden=purchaseStep===1;
      $('[data-purchase-choice]',purchase).textContent='Tono: '+choices[0];
      next.disabled=cartBusy||!selected?.available;
      next.textContent=adding?'Agregando…':purchaseStep===1?'Continuar con '+choices[0]+' →':!selected?.available?'Agotado':'Agregar al carrito';
      groups.forEach((group,i)=>{
        const copy=$('[data-purchase-option="'+i+'"]',purchase);if(!copy)return;
        $$('input',copy).forEach(input=>{input.checked=input.value===choices[i];input.disabled=$$('input',group).find(original=>original.value===input.value)?.disabled||false;});
        const legend=$('[data-option-label]',copy);if(legend)legend.textContent=choices[i];
        if(i>0)$$('label',copy).forEach((option,index)=>{
          const source=$$('label',group)[index];
          for(const attr of ['data-pack-price','data-pack-note','data-pack-saving','data-pack-compare']){
            const node=$('['+attr+']',option),value=$('['+attr+']',source);if(node&&value){node.textContent=value.textContent;node.hidden=value.hidden;}
          }
        });
      });
    }
    function updateVariant(updateURL=false) {
      const choices=values();selected=product.variants.find(v=>v.options.every((value,i)=>value===choices[i]));
      groups.forEach((group,index)=>{
        const optionLabel=$('[data-option-label]',group);if(optionLabel)optionLabel.textContent=choices[index]||'';
        if(index>0)$$('label',group).forEach(option=>{
          const value=$('input',option).value,match=product.variants.find(v=>v.options.every((v,i)=>i===index?v===value:v===choices[i]));
          const count=Number($('[data-pack-count]',option)?.dataset.packCount)||1,comparison=Number(match?.compare_at_price)||0;
          const discount=match&&comparison>match.price?Math.round((1-match.price/comparison)*100):0;
          const packPrice=$('[data-pack-price]',option),note=$('[data-pack-note]',option),saving=$('[data-pack-saving]',option),previous=$('[data-pack-compare]',option);
          if(packPrice)packPrice.textContent=match?purchaseMoney(match.price):'No disponible';
          if(note)note.textContent=match?purchaseMoney(Math.round(match.price/count/100)*100)+' por bote'+(!match.available?' · Agotado':''):'';
          if(saving){saving.hidden=discount<=0;saving.textContent='AHORRA '+discount+'%';}
          if(previous){previous.hidden=!match||comparison<=match.price;previous.textContent=comparison?purchaseMoney(Math.round(comparison/count)):'';}
          $('input',option).disabled=!match?.available;
        });
      });
      submit.disabled=cartBusy||!selected?.available;
      label.textContent=adding?'AGREGANDO…':!selected?'NO DISPONIBLE':!selected.available?'AGOTADO':'AGREGAR AL CARRITO';
      $$('[data-product-price]',section).forEach(node=>{node.textContent=selected?purchaseMoney(selected.price):'—';});
      $$('[data-total-currency]',section).forEach(node=>{node.textContent=currency;});
      $$('[data-total-pack]',section).forEach(node=>{node.textContent=selected?({'1 bote':'Compra 1','2 botes':'Compra 1 + 1 GRATIS','3 botes + 1 gratis':'Compra 2 + 2 GRATIS'}[choices[1]]||choices[1]):'No disponible';});
      const totalComparison=Number(selected?.compare_at_price)||0;
      const totalSaving=selected&&totalComparison>selected.price?Math.round((1-selected.price/totalComparison)*100):0;
      $$('[data-total-compare]',section).forEach(node=>{node.hidden=totalSaving<=0;node.textContent=totalComparison?purchaseMoney(totalComparison):'';});
      $$('[data-total-saving]',section).forEach(node=>{node.hidden=totalSaving<=0;node.textContent=totalSaving?'Ahorras '+totalSaving+'%':'';});
      $$('[data-closing-total]').forEach(node=>{node.textContent=selected?purchaseMoney(selected.price):'—';});
      $$('[data-closing-pack]').forEach(node=>{node.textContent=selected?({'1 bote':'Compra 1','2 botes':'Compra 1 + 1 GRATIS','3 botes + 1 gratis':'Compra 2 + 2 GRATIS'}[choices[1]]||choices[1]):'No disponible';});
      $$('[data-closing-tone]').forEach(node=>{node.textContent=selected?choices[0]:'—';});
      $$('[data-closing-compare]').forEach(node=>{node.hidden=totalSaving<=0;node.textContent=totalComparison?purchaseMoney(totalComparison):'';});
      $$('[data-closing-gifts]').forEach(node=>{node.textContent=(parseInt(choices[1],10)>=2?5:4)+' regalos incluidos';});
      $$('[data-closing-image]').forEach(node=>{const count=parseInt(choices[1],10)||1;node.src=node.dataset['pack'+count];node.alt=(choices[1]||'Paquete')+' de Bold Density';});
      $$('[data-final-purchase]').forEach(node=>{node.hidden=false;node.disabled=cartBusy||!selected?.available;node.textContent=adding?'AGREGANDO…':!selected?.available?'NO DISPONIBLE':'AGREGAR AL CARRITO';});
      if(selected){
        select.value=String(selected.id);currentVariant=selected.id;
        if(updateURL){const url=new URL(location.href);url.searchParams.set('variant',selected.id);try{history.replaceState(history.state,'',url);}catch{/* Keep the chosen variant even if this WebView rejects URL writes. */}}
      }else select.value='';
      if(stickyAdd){stickyAdd.disabled=cartBusy;stickyAdd.textContent=adding?'Agregando…':'Prueba Bold Density';}
      const giftsUnlocked=Boolean(selected);
      $$('[data-offer-gifts]',section).forEach(gifts=>{
        gifts.dataset.unlocked=String(Boolean(giftsUnlocked));
        $('[data-gift-status]',gifts).textContent=giftsUnlocked?'INCLUIDOS EN TU PACK':'ELIGE TU PACK';
        $$('[data-gift-badge]',gifts).forEach((badge,index)=>{badge.textContent=giftsUnlocked?(index?'REGALO':'GRATIS'):'ELIGE TU PACK';});
      });
      updatePurchase();
    }
    const initial=product.variants.find(v=>String(v.id)===select.value)||product.variants[0];
    groups.forEach((group,i)=>$$('input',group).forEach(input=>{
      input.checked=input.value===initial.options[i];input.addEventListener('change',()=>{errorBox.hidden=true;if(purchase)$('[data-purchase-error]',purchase).hidden=true;updateVariant(true);});
    }));
    if(purchase&&supportsDialog){
      groups.forEach((group,index)=>{
        const copy=group.cloneNode(true);copy.removeAttribute('data-option-index');copy.dataset.purchaseOption=String(index);
        $$('[id]',copy).forEach(node=>node.removeAttribute('id'));
        $$('input',copy).forEach(input=>{
          input.name='purchase-option-'+index;
          input.addEventListener('change',()=>{const original=$$('input',group).find(i=>i.value===input.value);if(original){original.checked=true;original.dispatchEvent(new Event('change',{bubbles:true}));}});
        });
        $(index===0?'[data-purchase-shades]':'[data-purchase-packs]',purchase).append(copy);
      });
      purchase.addEventListener('bold:step',event=>{purchaseStep=event.detail;updatePurchase();});
      $$('[data-purchase-back]',purchase).forEach(button=>button.addEventListener('click',()=>{
        if(historyMoving)return;
        if(memoryOverlay){memoryOverlay={...memoryOverlay,depth:Math.max(1,memoryOverlay.depth-1),stack:memoryOverlay.stack.map(entry=>entry.kind==='purchase'?{...entry,step:1}:entry)};syncDialogs(memoryOverlay);}
        else history.back();
      }));
      $('[data-purchase-next]',purchase).addEventListener('click',()=>{
        if(cartBusy||!selected?.available)return;
        if(purchaseStep===1){
          const state=overlayState();pushOverlay(state.stack.map(entry=>entry.kind==='purchase'?{...entry,step:2}:entry));
          $('[data-purchase-title]',purchase).focus({preventScroll:true});$('.purchase-body',purchase).scrollTop=0;
        }else if(form.requestSubmit)form.requestSubmit(submit);else submit.click();
      });
      $('[data-purchase-match]',purchase).addEventListener('click',()=>openMatcher($('[data-purchase-match]',purchase)));
    }
    section.classList.add('product-ready');updateVariant(true);
    document.addEventListener('bold:cart-busy',()=>updateVariant());
    form.addEventListener('submit',async event=>{
      if(!window.fetch||!supportsDialog)return;
      event.preventDefault();if(cartBusy||!selected?.available)return;
      adding=true;lockCart(true);errorBox.hidden=true;if(purchase)$('[data-purchase-error]',purchase).hidden=true;
      try{
        await post('cart/add.js',{items:[{id:selected.id,quantity:1}]});
        try{await refreshCart();replaceWithCart(purchase?.open?stickyAdd:submit);announce('Agregamos el producto a tu carrito.');}catch{location.assign(root+'cart');}
      }catch(error){
        errorBox.textContent=error.message;errorBox.hidden=false;
        if(purchase?.open){const box=$('[data-purchase-error]',purchase);box.textContent=error.message;box.hidden=false;box.scrollIntoView({block:'nearest'});}
      }finally{adding=false;lockCart(false);}
    });
    const help=$('[data-shade-help]',section),dialog=$('[data-shade-dialog]',section),guide=$('[data-shade-guide]',section);let loadingMatcher;
    const chooseShade=name=>{const input=$$('input',groups[0]).find(i=>i.value===name);if(input){input.checked=true;input.dispatchEvent(new Event('change',{bubbles:true}));}};
    async function openMatcher(opener) {
      if(!dialog||typeof dialog.showModal!=='function'){location.assign(root+'pages/contacto');return;}
      openDialog(dialog,opener);
      if(!loadingMatcher)loadingMatcher=import(dialog.dataset.matcherModule).then(module=>{
        module.setupShadeMatcher(dialog,{getShades:()=>product.variants.filter(v=>v.available&&v.options.slice(1).every((o,i)=>o===values()[i+1])).map(v=>v.options[0]),onSelect:chooseShade});
        $('[data-matcher-content]',dialog).hidden=false;$('[data-matcher-loading]',dialog).hidden=true;
      }).catch(()=>{loadingMatcher=null;$('[data-matcher-loading]',dialog).textContent='No pudimos cargar el analizador. Puedes elegir un tono abajo o volver a abrirlo.';});
      await loadingMatcher;
    }
    if(help&&dialog&&guide){
      $$('input',groups[0]).forEach(input=>{
        const item=el('button','shade-guide-choice'),swatch=el('span','swatch');item.type='button';swatch.dataset.shade=input.value;
        const source=input.nextElementSibling?.querySelector('img');if(source)swatch.append(source.cloneNode(true));
        item.append(swatch,el('span','',input.value));item.addEventListener('click',()=>{chooseShade(input.value);closeDialog(dialog);});guide.append(item);
      });
      help.addEventListener('click',()=>openMatcher(help));
    }
    $$('[data-final-purchase]').forEach(node=>node.addEventListener('click',event=>{event.preventDefault();if(!cartBusy&&selected?.available)form.requestSubmit(submit);}));
    const sticky=$('[data-sticky-buy]',section);
    if(sticky){
      const stickyOffset=120;
      let threshold=Infinity,frame=0,closingInView=false;
      const updateSticky=()=>{sticky.hidden=window.scrollY<=threshold||closingInView;};
      const finalPurchase=$('[data-final-purchase]');
      if(finalPurchase&&'IntersectionObserver'in window){const closingObserver=new IntersectionObserver(entries=>{closingInView=entries[0].isIntersecting&&entries[0].intersectionRatio>=.5;updateSticky();},{threshold:[0,.5,1]});closingObserver.observe(finalPurchase);}
      const measure=()=>{frame=0;threshold=window.scrollY+submit.getBoundingClientRect().bottom+stickyOffset;updateSticky();};
      const schedule=()=>{if(!frame)frame=requestAnimationFrame(measure);};
      // Cache the document position; scroll jumps can skip both observer intersection states.
      document.addEventListener('scroll',updateSticky,{passive:true});
      window.addEventListener('resize',schedule,{passive:true});window.addEventListener('pageshow',schedule);
      section.addEventListener('change',schedule);
      if('ResizeObserver'in window){const resize=new ResizeObserver(schedule);resize.observe(section);resize.observe(form);}
      document.fonts?.ready.then(schedule);measure();
    }
    stickyAdd?.addEventListener('click',()=>{
      if(purchase&&supportsDialog){updatePurchase();openDialog(purchase,stickyAdd);}
      else groups[0]?.scrollIntoView({behavior:motion.matches?'instant':'smooth',block:'center'});
    });
    window.addEventListener('pageshow',()=>{adding=false;updateVariant();});
  }

  // Scroll snap supplies touch inertia; the small enhancement adds keyboard/dot controls.
  function setupCarousel(carousel) {
    if(carousel.dataset.ready)return;carousel.dataset.ready='true';
    const track=$('[data-carousel-track]',carousel),cards=Array.from(track.children),dots=$$('[data-carousel-index]',carousel);
    let active=0,frame=0;
    const update=()=>{
      frame=0;const center=track.getBoundingClientRect().left+track.clientWidth/2;
      active=cards.reduce((best,card,index)=>Math.abs(card.getBoundingClientRect().left+card.clientWidth/2-center)<Math.abs(cards[best].getBoundingClientRect().left+cards[best].clientWidth/2-center)?index:best,0);
      dots.forEach((dot,index)=>dot.setAttribute('aria-pressed',String(index===active)));
      $$('[data-carousel-step]',carousel).forEach(button=>{button.disabled=Number(button.dataset.carouselStep)<0?active===0:active===cards.length-1;});
    };
    const go=index=>{const card=cards[Math.max(0,Math.min(cards.length-1,index))];track.scrollTo({left:track.scrollLeft+card.getBoundingClientRect().left-track.getBoundingClientRect().left-(track.clientWidth-card.clientWidth)/2,behavior:motion.matches?'instant':'smooth'});};
    $$('[data-carousel-step]',carousel).forEach(button=>button.addEventListener('click',()=>go(active+Number(button.dataset.carouselStep))));
    dots.forEach(button=>button.addEventListener('click',()=>go(Number(button.dataset.carouselIndex))));
    track.addEventListener('scroll',()=>{if(!frame)frame=requestAnimationFrame(update);},{passive:true});
    track.addEventListener('keydown',event=>{if(event.target!==track)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();go(active+(event.key==='ArrowRight'?1:-1));}});
    if(carousel.classList.contains('demo-carousel')&&cards[1]&&matchMedia('(max-width:989px)').matches){
      track.scrollLeft=cards[1].getBoundingClientRect().left-track.getBoundingClientRect().left-(track.clientWidth-cards[1].clientWidth)/2;
    }
    if('ResizeObserver'in window)new ResizeObserver(update).observe(track);update();
  }
  const carouselObserver='IntersectionObserver'in window?new IntersectionObserver(entries=>entries.forEach(entry=>{
    if(entry.isIntersecting){carouselObserver.unobserve(entry.target);setupCarousel(entry.target);}
  }),{rootMargin:'100% 0px'}):null;
  const prepareCarousel=carousel=>carouselObserver?carouselObserver.observe(carousel):setupCarousel(carousel);
  $$('[data-carousel]').forEach(prepareCarousel);
  $$('[data-ticker]').forEach(ticker=>{
    const button=$('[data-ticker-toggle]',ticker);ticker.dataset.visible='true';
    button.addEventListener('click',()=>{const paused=button.getAttribute('aria-pressed')!=='true';button.setAttribute('aria-pressed',String(paused));button.setAttribute('aria-label',paused?'Reanudar franja':'Pausar franja');button.firstElementChild.textContent=paused?'▶':'Ⅱ';ticker.dataset.paused=String(paused);});
    if('IntersectionObserver'in window)new IntersectionObserver(entries=>{ticker.dataset.visible=String(entries[0].isIntersecting);}).observe(ticker);
  });
  $('[data-back-top]')?.addEventListener('click',()=>window.scrollTo({top:0,behavior:motion.matches?'instant':'smooth'}));

  const miniDialog=$('[data-mini-dialog]'),miniButtons=$$('[data-mini-video]');
  if(miniDialog&&typeof miniDialog.showModal==='function'){
    const player=$('[data-mini-player]',miniDialog);let activeMini=0;
    const playMini=index=>{activeMini=(index+miniButtons.length)%miniButtons.length;const preview=$('video',miniButtons[activeMini]);player.pause();player.src=$('source',preview).src;player.poster=preview.poster||preview.dataset.poster;player.load();player.play().catch(()=>{});};
    miniButtons.forEach((button,index)=>button.addEventListener('click',()=>{openDialog(miniDialog,button);playMini(index);}));
    $$('[data-mini-step]',miniDialog).forEach(button=>button.addEventListener('click',()=>playMini(activeMini+Number(button.dataset.miniStep))));
    miniDialog.addEventListener('close',()=>{player.pause();player.removeAttribute('src');player.removeAttribute('poster');player.load();});
  }else miniButtons.forEach(button=>button.addEventListener('click',()=>{const video=$('video',button);video.controls=true;video.muted=false;video.play().catch(()=>{});}));
  $$('[data-product-section]').forEach(setupProduct);
  window.addEventListener('pageshow',event=>{
    checkoutSubmitted=false;checkoutOpening=false;$('[data-checkout]')?.removeAttribute('aria-busy');lockCart(false);
    if(supportsDialog){syncDialogs(overlayState());if(drawer.open||event.persisted)loadCart();}
    if(event.persisted)syncPlayback();
  });
  document.addEventListener('shopify:section:load',event=>{
    $$('[data-product-section]',event.target).forEach(setupProduct);$$('[data-carousel]',event.target).forEach(prepareCarousel);
  });

  // Start photos and video posters 1.5 viewports ahead, without a second lazy wait.
  // Templates keep distant carousel photos out of the initial download and retain a no-JS fallback.
  const prepareMedia=target=>{
    if(target.matches('[data-deferred-media]')){
      const content=$('template',target).content.cloneNode(true);
      $$('img',content).forEach(image=>{image.loading='eager';});
      target.replaceWith(content);
    }else if(target.matches('video'))target.poster=target.dataset.poster;
    else target.loading='eager';
  };
  const pendingMedia=new Set($$('[data-deferred-media], img[loading="lazy"], video[data-poster]'));
  if('IntersectionObserver'in window){
    const criticalImage=$('img[fetchpriority="high"]');
    let mediaObserver,mediaLead=0,mediaReady=!criticalImage||criticalImage.complete;
    const observeMedia=()=>{
      const height=Math.ceil(document.documentElement.clientHeight*1.5);
      if(!mediaReady||!pendingMedia.size||Math.abs(height-mediaLead)<100)return;
      mediaLead=height;mediaObserver?.disconnect();
      mediaObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{
        if(entry.isIntersecting){mediaObserver.unobserve(entry.target);pendingMedia.delete(entry.target);prepareMedia(entry.target);}
      }),{rootMargin:mediaLead+'px 250px'});
      pendingMedia.forEach(target=>mediaObserver.observe(target));
    };
    if(!mediaReady){const ready=()=>{mediaReady=true;requestAnimationFrame(observeMedia);};criticalImage.addEventListener('load',ready,{once:true});criticalImage.addEventListener('error',ready,{once:true});}
    observeMedia();window.addEventListener('resize',observeMedia,{passive:true});
  }else pendingMedia.forEach(prepareMedia);

  // No video bytes or photo-analysis module on initial load; stop decoding offscreen.
  const videos=$$('video[data-play-in-view]'),visibleVideos=new Set(),manualVideos=new WeakSet();
  videos.forEach(video=>{for(const event of ['pointerdown','keydown'])video.addEventListener(event,()=>manualVideos.add(video),{passive:true});});
  syncPlayback=()=>{
    const background=document.hidden||!!$('dialog[open]');
    const connection=navigator.connection;
    const limited=motion.matches||connection?.saveData||/^(slow-2g|2g|3g)$/.test(connection?.effectiveType||'')||(connection?.downlink&&connection.downlink<1)||(navigator.deviceMemory&&navigator.deviceMemory<=2)||(navigator.hardwareConcurrency&&navigator.hardwareConcurrency<=2);
    const candidates=Array.from(visibleVideos);
    const center=innerWidth/2;
    const automatic=limited||candidates.some(video=>manualVideos.has(video)&&!video.paused)?null:candidates.reduce((best,video)=>{const r=video.getBoundingClientRect(),distance=Math.abs(r.left+r.width/2-center);return !best||distance<best.distance?{video,distance}:best;},null)?.video;
    for(const video of videos){
      if(background||!visibleVideos.has(video)){video.pause();continue;}
      if(manualVideos.has(video))continue;
      if(video!==automatic){video.pause();continue;}
      if(video.paused)video.play().catch(()=>{/* A tap/native controls still work if the WebView blocks autoplay. */});
    }
    $$('[data-ticker]').forEach(ticker=>{ticker.dataset.background=String(background);});
  };
  if('IntersectionObserver'in window){
    const observer=new IntersectionObserver(entries=>{
      entries.forEach(entry=>{if(entry.isIntersecting&&entry.intersectionRatio>=0.35)visibleVideos.add(entry.target);else visibleVideos.delete(entry.target);});syncPlayback();
    },{threshold:[0,0.35]});videos.forEach(video=>observer.observe(video));
  }
  document.addEventListener('visibilitychange',()=>{if(document.hidden)$$('video').forEach(video=>video.pause());syncPlayback();});
  window.addEventListener('pagehide',()=>$$('video').forEach(video=>video.pause()));
  motion.addEventListener?.('change',syncPlayback);navigator.connection?.addEventListener('change',syncPlayback);
  // Homepage tone guide: links work without JS; the photo matcher loads only on request.
  const homeShades=$('[data-home-shade-section]');
  if(homeShades){
    const help=$('[data-home-shade-help]',homeShades),dialog=$('[data-shade-dialog]',homeShades),guide=$('[data-shade-guide]',homeShades),tones=$$('[data-home-tone]',homeShades);let loadingMatcher;
    const goTo=name=>{
      const link=tones.find(a=>a.dataset.homeTone===name);if(!link)return;
      if(overlayState().depth){nextOverlay=()=>location.assign(link.href);closeDialog(dialog);}else location.assign(link.href);
    };
    if(help&&dialog&&guide&&typeof dialog.showModal==='function'){
      tones.forEach(link=>{
        const item=el('button','shade-guide-choice'),swatch=el('span','swatch'),img=$('img',link);item.type='button';swatch.dataset.shade=link.dataset.homeTone;
        if(img)swatch.append(img.cloneNode(true));
        item.append(swatch,el('span','',link.dataset.homeTone));item.addEventListener('click',()=>goTo(link.dataset.homeTone));guide.append(item);
      });
      help.addEventListener('click',async event=>{
        event.preventDefault();openDialog(dialog,help);
        if(!loadingMatcher)loadingMatcher=import(dialog.dataset.matcherModule).then(module=>{
          module.setupShadeMatcher(dialog,{getShades:()=>tones.map(a=>a.dataset.homeTone),onSelect:goTo});
          $('[data-matcher-content]',dialog).hidden=false;$('[data-matcher-loading]',dialog).hidden=true;
        }).catch(()=>{loadingMatcher=null;$('[data-matcher-loading]',dialog).textContent='No pudimos cargar el analizador. Puedes elegir un tono abajo o volver a abrirlo.';});
        await loadingMatcher;
      });
    }
  }
})();

